var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C6.1443 1.00265 4.36536 1.74099 3.05317 3.05317C1.74099 4.36536 1.00265 6.1443 1 8C1.00265 9.8557 1.74099 11.6346 3.05317 12.9468C4.36536 14.259 6.1443 14.9974 8 15C9.8557 14.9974 11.6346 14.259 12.9468 12.9468C14.259 11.6346 14.9974 9.8557 15 8C14.9974 6.1443 14.259 4.36536 12.9468 3.05317C11.6346 1.74099 9.8557 1.00265 8 1V1ZM8 14C4.802 14 2 11.198 2 8C2 4.802 4.802 2 8 2C11.198 2 14 4.802 14 8C14 11.198 11.198 14 8 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00231 6.48928C8.31031 6.48928 8.55931 6.73828 8.55931 7.04628V10.9443C8.55931 11.2523 8.31031 11.5013 8.00231 11.5013C7.69431 11.5013 7.44531 11.2523 7.44531 10.9443V7.04528C7.44531 6.73728 7.69431 6.48828 8.00231 6.48828V6.48928Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55931 5.057C8.55931 5.365 8.31031 5.614 8.00231 5.614C7.69431 5.614 7.44531 5.365 7.44531 5.057C7.44531 4.749 7.69431 4.5 8.00231 4.5C8.31031 4.5 8.55931 4.749 8.55931 5.057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.9a3a51fef49e8aa4f64b0400a0569b67.svg";
export { ForwardRef as ReactComponent };